import React, { ReactNode, createContext, useContext } from 'react';
import gun from '../../config/gun.config';

const GunContext = createContext(gun);
export const useGun = () => useContext(GunContext);

export function GunProvider({ children }: { children: ReactNode }) {
  return <GunContext.Provider value={gun}>{children}</GunContext.Provider>;
}
